import MockAdapter from 'axios-mock-adapter'

import {saveScenario, sleepResponse, uuidRegEx} from './utils'

import {mockStore} from '@settings/__mock__/mockStore'

export const enableRefraPlannerEndpoints = (mock: MockAdapter) => {
  mock
    .onGet(new RegExp(`/plants/${uuidRegEx}/refractory-planner/kilns/${uuidRegEx}/settings`))
    .reply(() => {
      const scenario = mockStore.scenario()
      const {
        burglengenfeld: {refraSettings}
      } = scenario
      return sleepResponse([200, refraSettings])
    })

  // Mock heat zones settings API
  mock.onGet(/\/plants\/refractory-planner\/kilns\/settings\/heat-zones/).reply(() => {
    // Return the list of available heat zone enum values
    return sleepResponse([
      200,
      [
        'KilnOutlet',
        'LowerTransitionZone',
        'BurningZone',
        'UpperTransitionZone',
        'SafetyZone',
        'CalcinationZone',
        'PreheatingZone',
        'KilnInlet',
        'DryZone'
      ]
    ])
  })

  mock
    .onPatch(new RegExp(`/plants/${uuidRegEx}/refractory-planner/kilns/${uuidRegEx}/settings`))
    .reply((config) => {
      const payload = JSON.parse(config.data as string)
      const scenario = mockStore.scenario()

      scenario.burglengenfeld.refraSettings = {...scenario.burglengenfeld.refraSettings, ...payload}

      saveScenario(scenario)
      return sleepResponse([200, {}])
    })
}
